import React from 'react';
import { Button } from '../../../components/base/Button';

export const AboutSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Why Choose Us Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <i className="ri-tools-line text-red-600 text-2xl"></i>
              <span className="text-red-600 font-semibold text-lg">About Device Doctor</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Your Trusted Mobile & Gadget Service Hub in Kochi
            </h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Device Doctor is one of the best mobile repair shops in Kochi, offering expert mobile, tablet, 
              smartwatch, and gadget repair services using 100% genuine parts and certified technicians.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-red-600 text-sm"></i>
                </div>
                <span className="text-gray-700">Certified Technicians</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-red-600 text-sm"></i>
                </div>
                <span className="text-gray-700">Genuine Parts Only</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-red-600 text-sm"></i>
                </div>
                <span className="text-gray-700">Same-Day Service</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-red-600 text-sm"></i>
                </div>
                <span className="text-gray-700">All-Kerala Courier Services</span>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => scrollToSection('services')}
                size="lg"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-full whitespace-nowrap"
              >
                View Our Services
              </Button>
              <Button 
                onClick={() => scrollToSection('contact')}
                variant="outline" 
                size="lg"
                className="border-2 border-gray-300 text-gray-700 hover:bg-gray-50 px-8 py-3 rounded-full whitespace-nowrap"
              >
                Contact Us
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-gradient-to-br from-red-100 to-red-50 rounded-3xl p-8 relative overflow-hidden">
              <img
                src="/assets/about-main.jpg"
                alt="Professional mobile repair service"
                className="rounded-2xl shadow-xl object-cover w-full h-80"
              />
              
              <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl p-6 shadow-xl">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                    <i className="ri-award-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-2xl">5000+</p>
                    <p className="text-sm text-gray-600">Happy Customers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
